// third-party
import { Trans } from "react-i18next";

// assets
import {
  IconBuildingStore,
  IconBinaryTree,
  IconReceiptTax,
  IconBallFootball,
  IconTractor,
  IconCalculator,
  IconBuilding,
} from "@tabler/icons";
import { OverrideIcon } from "types";

// constant
const icons = {
  IconBuildingStore,
  IconBinaryTree,
  IconReceiptTax,
  IconBallFootball,
  IconTractor,
  IconCalculator,
  IconBuilding,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface listmemberRegisterMenuProps {
  id: string;
  title: React.ReactNode | string;
  type: string;
  children: {
    id: string;
    title: React.ReactNode | string;
    type: string;
    url: string;
    icon: OverrideIcon;
    breadcrumbs: boolean;
  }[];
}
const memberRegister: listmemberRegisterMenuProps = {
  id: "member",
  title: (
    <Trans
      i18nKey="Member"
      id="Member"
    />
  ),
  type: "group",
  children: [
    {
      id: "member-register",
      title: (
        <Trans
          i18nKey="Member Registration"
          id="Member Registration"
        />
      ),
      type: "item",
      url: "/member-register",
      icon: icons.IconBinaryTree,
      breadcrumbs: false,
    },
    // {
    //   id: "member-register-new",
    //   title: (
    //     <Trans
    //       i18nKey="Member"
    //       id="Member"
    //     />
    //   ),
    //   type: "item",
    //   url: "/member-register-new",
    //   icon: icons.IconBinaryTree,
    //   breadcrumbs: false,
    // },
    {
      id: "vat-info",
      title: (
        <Trans
          i18nKey="VAT Info"
          id="VAT Info"
        />
      ),
      type: "item",
      url: "/vat-info",
      icon: icons.IconReceiptTax,
      breadcrumbs: false,
    },
    {
      id: "vat-get-info",
      title: (
        <Trans
          i18nKey="VAT Get Info"
          id="VAT Get Info"
        />
      ),
      type: "item",
      url: "/vat-get-info",
      icon: icons.IconCalculator,
      breadcrumbs: false,
    },
    {
      id: "master-company",
      title: (
        <Trans
          i18nKey="Companies"
          id="Companies"
        />
      ),
      type: "item",
      url: "/master-company",
      icon: icons.IconBuilding,
      breadcrumbs: false,
    },
    {
      id: "goods-refund",
      title: (
        <Trans
          i18nKey="Goods refund"
          id="Goods Refund"
        />
      ),
      type: "item",
      url: "/goods-refund",
      icon: icons.IconBallFootball,
      breadcrumbs: false,
    },
    {
      id: "goods-delivery",
      title: (
        <Trans
          i18nKey="Goods delivery"
          id="Goods Delivery"
        />
      ),
      type: "item",
      url: "/goods-delivery",
      icon: icons.IconTractor,
      breadcrumbs: false,
    },
  ],
};

export default memberRegister;
